import { Pipe, PipeTransform } from '@angular/core';
import { AurCurrencyPipe } from '@arc/aureus';
import { Store } from '@ngrx/store';
import { selectCurrentLanguage, TranslateStoreState } from '../store';

@Pipe({
  name: 'currency',
})
export class InternationalCurrencyPipe implements PipeTransform {
  private currentLanguage: string;

  constructor(
    private translateStore: Store<TranslateStoreState>,
    private aurCurrencyPipe: AurCurrencyPipe,
  ) {
    this.translateStore.select(selectCurrentLanguage).subscribe((language) => {
      this.currentLanguage = language;
    });
  }

  public transform(value: number | string): string {
    const currency = this.aurCurrencyPipe.transform(
      value,
      '', // Blank to omit the Currency Code since null is not supported
      '1.2-2', // 1 min digits. 2 min & max for decimal points
      this.currentLanguage,
    );
    return currency;
  }
}
